import React from 'react';
import { Box, Flex, Text, H4 } from '@opendoor/bricks/core';
import { WrapperCard } from 'sellDirect/components/legacy/sellerDash/exteriorAssessment/WrapperCard';
import { AGENT_ACQ_EMAIL } from 'shared/helpers/globals';
import { ExternalLink } from 'platform/react-router';
import { useSupportContacts } from 'sellDirect/helpers/useSupportContacts';

interface NoAvailableSlotsProps {
  shouldSeeAgentExperience?: boolean;
}

/**
 * TODO: Add documentation
 * @deprecated This is a legacy component. Do not use.
 */
export const NoAvailableSlots: React.FC<NoAvailableSlotsProps> = ({ shouldSeeAgentExperience }) => {
  const { CXA_EMAIL } = useSupportContacts();

  const contactEmail = shouldSeeAgentExperience ? AGENT_ACQ_EMAIL : CXA_EMAIL;

  return (
    <>
      <WrapperCard>
        <Flex width="100%" alignItems="center" justifyContent="center">
          <H4>No available times</H4>
        </Flex>
      </WrapperCard>
      <Box mt={9} textAlign="center">
        <Text textAlign="center" mx={5} mb={7}>
          Looks like we don't have any available appointments within the next few weeks.
        </Text>
        <Text as="span" textAlign="center" mx={5}>
          Email{' '}
          <ExternalLink
            analyticsName="legacy-cake-cxa-email"
            href={`mailto:${contactEmail}`}
            aria-label="Email Opendoor to schedule an appointment"
          >
            {contactEmail}
          </ExternalLink>{' '}
          and we'll help you find a time.
        </Text>
      </Box>
    </>
  );
};
